(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["airborne-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('af-footwear-size-guide')) {
    class AirborneFootwearSizeGuide extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-guide-open]')) {
            const picker = this.closest('.product-details');
            const selected = picker?.querySelector('input[data-option-name="Size"]:checked') || picker?.querySelector('select[name^="options[Size]"]');
            const size = selected?.value.replace(/\s*UK\s*/i, '').trim();
            this.querySelectorAll('[data-guide-size]').forEach((row) => {
              if (row.dataset.guideSize === size) row.setAttribute('aria-current', 'true');
              else row.removeAttribute('aria-current');
            });
            if (!this.dialog.open) this.dialog.showModal();
            this.querySelector('tbody:not([hidden]) [aria-current="true"]')?.scrollIntoView({ block: 'nearest' });
          }
          if (event.target.closest('[data-guide-close]')) this.dialog.close();
          const genderButton = event.target.closest('[data-guide-gender]');
          if (genderButton) {
            const gender = genderButton.dataset.guideGender;
            this.querySelectorAll('[data-guide-gender]').forEach((button) => button.setAttribute('aria-pressed', String(button === genderButton)));
            this.querySelectorAll('[data-guide-chart]').forEach((chart) => { chart.hidden = chart.dataset.guideChart !== gender; });
            const category = this.querySelector('[data-guide-category]');
            category.textContent = gender === 'men' ? category.dataset.menLabel : category.dataset.womenLabel;
            this.querySelector('.af-size-guide__table-wrap').scrollTop = 0;
            this.querySelector('tbody:not([hidden]) [aria-current="true"]')?.scrollIntoView({ block: 'nearest' });
          }
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('af-footwear-size-guide', AirborneFootwearSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["airborne-ugg-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('af-ugg-size-guide')) {
    class AirborneUggSizeGuide extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-guide-open]')) {
            const picker = this.closest('variant-picker');
            const selected = picker?.querySelector('input[data-option-name="Size"]:checked') || picker?.querySelector('select[name^="options[Size]"]');
            const size = selected?.value.replace(/\s*UK\s*/i, '').trim();
            this.querySelectorAll('[data-guide-size]').forEach((row) => {
              if (row.dataset.guideSize === size) row.setAttribute('aria-current', 'true');
              else row.removeAttribute('aria-current');
            });
            if (!this.dialog.open) this.dialog.showModal();
            this.querySelector('[aria-current="true"]')?.scrollIntoView({ block: 'nearest' });
          }
          if (event.target.closest('[data-guide-close]')) this.dialog.close();
          const unit = event.target.closest('[data-guide-unit]');
          if (unit) {
            const inches = unit.dataset.guideUnit === 'in';
            this.querySelectorAll('[data-guide-unit]').forEach((button) => button.setAttribute('aria-pressed', String(button === unit)));
            this.querySelectorAll('[data-guide-cm]').forEach((cell) => { cell.textContent = inches ? cell.dataset.guideIn : cell.dataset.guideCm; });
            this.querySelector('[data-guide-unit-label]').textContent = `(${unit.textContent})`;
          }
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('af-ugg-size-guide', AirborneUggSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
